export enum BOMoniebookOnboardingStatus {
    NOT_REGISTERED = 'NOT_REGISTERED',
    REGISTERED = 'REGISTERED',
    TERMINAL_PAIRED = 'TERMINAL_PAIRED',
}

export interface BOMoniebookOnboardingStatusResponse {
    status: BOMoniebookOnboardingStatus;
}

export interface BOMoniebookOnboardingRequest {
    boCode: string;
}

export enum MoniebookBusinessOnboardingStatus {
    ONBOARDED = 'ONBOARDED',
    NOT_ONBOARDED = 'NOT_ONBOARDED',
}

export interface MoniebookBusinessOnboardingStatusResponse {
    status: MoniebookBusinessOnboardingStatus;
}
